// client/src/utils/image.js
// 图片压缩工具: 贴牌背景图/Logo 上传前在前端压缩, 避免大 base64 拖垮接口和数据库

/**
 * 压缩图片文件为 JPEG dataURL
 * @param {File} file 原始图片文件
 * @param {Object} opts { maxDim: 最长边像素(默认1920), quality: JPEG质量(默认0.85) }
 * @returns {Promise<string>} dataURL (image/jpeg;base64,...)
 */
export const compressImage = (file, opts = {}) => {
  const maxDim = opts.maxDim || 1920;
  const quality = opts.quality || 0.85;

  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      reject(new Error('请上传图片文件'));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('图片读取失败'));
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = () => reject(new Error('图片解析失败, 可能已损坏'));
      img.onload = () => {
        let { width, height } = img;
        // 等比缩小到最长边 maxDim 以内(小图不放大)
        if (Math.max(width, height) > maxDim) {
          const ratio = maxDim / Math.max(width, height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        try {
          resolve(canvas.toDataURL('image/jpeg', quality));
        } catch (err) {
          reject(new Error('图片压缩失败: ' + err.message));
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

/**
 * dataURL 的 base64 部分字节数(不含头部), 用于前端预估大小
 */
export const dataUrlBytes = (dataUrl) => {
  if (typeof dataUrl !== 'string') return 0;
  const idx = dataUrl.indexOf(',');
  if (idx < 0) return 0;
  const b64 = dataUrl.slice(idx + 1);
  return Math.floor((b64.length * 3) / 4);
};

/**
 * 人类可读的文件大小
 */
export const formatBytes = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1024 / 1024).toFixed(2) + ' MB';
};
